/**
 * File preview size limits based on browser performance research
 *
 * - Images: 10 MB (browser rendering threshold)
 * - PDFs: 25 MB (conservative limit for encrypted files)
 * - Text: 5 MB (~5 million characters, DOM rendering limit)
 */
export const FILE_PREVIEW_LIMITS = {
  image: 10 * 1024 * 1024, // 10 MB
  pdf: 25 * 1024 * 1024, // 25 MB
  text: 5 * 1024 * 1024, // 5 MB
} as const;
